var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回")]),_c('iframe',{attrs:{"src":_vm.iframeSrc,"height":"1000","width":"1700"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }